<template>
  <div id="page-personnel-edit">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Liste Assurance" icon-pack="feather" icon="icon-users">
            <div class="tab-text">
              <assurance-list-tab></assurance-list-tab>
            </div>
          </vs-tab>
          <vs-tab label="Nouveau" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <assurance-add-tab></assurance-add-tab>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import AssuranceAddTab from './assurance_add.vue'
import AssuranceListTab from './assurance_list.vue'
export default {
  name: 'AssuranceView',
  components: {
    AssuranceAddTab,
    AssuranceListTab
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>

<style scoped>

</style>
